// Reports performance views (assessment / completion / written-exam tabs).
// Prefix: qcw-. Glass migration guided by the design ReportsScreen perf tables
// (rp-list) + overall cards (rp-overall / rp-chartwrap): frosted table card with
// transparent/translucent zebra rows, hairline glass dividers, a brand-tinted
// index pill, and frosted overall-score cards. Markup is unchanged — styling only.
export const reportCardViewStyles = `
/* Solid frost (no live backdrop-filter): large cards on the scrolling reports
   page re-rasterize a blur(24px) every scroll frame → jank. --glass-flat-solid
   carries the frosted look statically (per its own guidance in index.css). */
.qcw-table-wrap {
  overflow: hidden;
  border-radius: var(--rad-catchup-large);
  border: 1px solid var(--glass-flat-border);
  background: var(--glass-flat-solid);
  -webkit-backdrop-filter: none;
  backdrop-filter: none;
  box-shadow: var(--glass-flat-edge), var(--glass-flat-float-rest);
}
.qcw-table {
  width: 100%;
}
.qcw-thead-row {
  background-color: rgba(255, 255, 255, 0.55);
  border-bottom: 1px solid var(--glass-flat-border);
}
.qcw-th-index {
  width: 3rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.qcw-th {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.qcw-th-left {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  text-align: left;
}
.qcw-tbody {
}
.qcw-tbody > tr + tr {
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: var(--glass-flat-border);
}
.qcw-row {
  text-align: center;
  transition: color var(--duration-base) var(--ease-standard), background-color var(--duration-base) var(--ease-standard), border-color var(--duration-base) var(--ease-standard);
}
.qcw-row:hover {
  background-color: rgba(84, 187, 203, 0.10);
}
.qcw-row-even {
  background-color: rgba(255, 255, 255, 0.45);
}
.qcw-row-odd {
  background-color: transparent;
}
.qcw-td-index {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.qcw-td {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.qcw-td-feedback {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  text-align: center;
  vertical-align: middle;
}
.qcw-index-pill {
  display: inline-flex;
  height: 1.75rem;
  width: 1.75rem;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-color: var(--brand-100);
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--brand-darker);
}
.qcw-info-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 0.5rem;
}
.qcw-name-cell {
  flex: 1 1 0%;
  text-align: start;
}
.qcw-name-text {
  font-size: var(--fs-base);
  font-weight: 500;
  color: var(--text-primary);
}
.qcw-status-row {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 0.375rem;
}
.qcw-status-text {
  font-size: var(--fs-md);
  color: var(--text-muted);
}
.qcw-detail-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.qcw-feedback-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.qcw-feedback-arrow-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  column-gap: 0.5rem;
}
.qcw-cursor-pointer {
  cursor: pointer;
}
.qcw-feedback-td {
  width: 100%;
  overflow: hidden;
  padding: 0;
}
.qcw-feedback-panel {
  transition: all 500ms ease-in-out;
  background-color: var(--brand-50);
  overflow: hidden;
}
.qcw-feedback-panel-open {
  max-height: 100%;
  opacity: 1;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.qcw-feedback-panel-closed {
  max-height: 0;
  opacity: 0;
  padding-top: 0;
  padding-bottom: 0;
}
.qcw-feedback-inner {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.qcw-w-full {
  width: 100%;
}
.qcw-pager {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}
.qcw-date-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.qcw-date-primary {
  font-size: var(--fs-base);
  font-weight: 500;
  color: var(--text-secondary);
}
.qcw-date-secondary {
  font-size: var(--fs-md);
  color: var(--text-muted);
}
.qcw-header-text {
  font-size: var(--fs-md);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
}
.qcw-doughnut-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 0.5rem;
}
.qcw-doughnut-dot {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: var(--rad-catchup-full);
}
.qcw-doughnut-title {
  font-size: var(--fs-md);
  cursor: default;
}
.qcw-minimized-root {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
/* Dashboard report preview: only the corporate score-lanes chart (no donut
   rings, no inner card, no chart title — the Raporlar card is already a card). */
.qcw-mini-perf {
  margin-top: var(--space-3);
}
/* "Ders" label + GlassSelect group (mirrors the /reports sap-fgroup; the sap-
   styles aren't injected on the dashboard so they're re-declared locally). */
.qcw-fgroup {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  flex-wrap: wrap;
}
.qcw-fgroup-lbl {
  font-size: var(--fs-md);
  font-weight: 700;
  color: var(--text-muted);
  flex-shrink: 0;
}
.qcw-flex-1-min-0 {
  flex: 1 1 0%;
  min-height: 0;
}
.qcw-graph-data-row {
  display: flex;
  flex: 1 1 0%;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}
.qcw-graph-left {
  display: none;
}
.qcw-graph-right {
  width: 100%;
}
.qcw-overall-card-left {
  border-radius: var(--rad-catchup-large);
  border: 1px solid var(--glass-flat-border);
  background: var(--glass-flat-solid);
  -webkit-backdrop-filter: none;
  backdrop-filter: none;
  padding: 1rem;
  box-shadow: var(--glass-flat-edge), var(--glass-flat-float-rest);
  margin-right: 1rem;
}
.qcw-overall-card-right {
  border-radius: var(--rad-catchup-large);
  border: 1px solid var(--glass-flat-border);
  background: var(--glass-flat-solid);
  -webkit-backdrop-filter: none;
  backdrop-filter: none;
  padding: 1rem;
  box-shadow: var(--glass-flat-edge), var(--glass-flat-float-rest);
  margin-left: 1rem;
}
.qcw-card-title-wrap {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.qcw-card-title {
  font-weight: 700;
  font-size: var(--fs-lg);
}
.qcw-doughnut-headers-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  column-gap: 1rem;
  row-gap: 0.5rem;
}
.qcw-doughnut-wrap {
  max-width: 350px;
  margin: auto;
}
.qcw-modal-section {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.qcw-modal-section-inner {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.qcw-rotated-label {
  transform: rotate(-90deg);
}
.qcw-rotated-label-text {
  font-size: var(--fs-xl);
  color: var(--brand-darker);
}
.qcw-radar-pair {
  flex: 1 1 0%;
  display: flex;
}
.qcw-radar-half {
  width: 100%;
}
.qcw-content-col {
  display: flex;
  flex: 1 1 0%;
  flex-direction: column;
}
/* Genel durum yığını. "Zaman içindeki gelişimin" grafiği, ön koşul kartı ve her dersin öğrenme çıktısı
   ağacı arka arkaya diziliyor — ve hiçbirinin kendi dış boşluğu yok, dolayısıyla kartlar
   birbirine yapışık çıkıyordu. Boşluğu kartlara tek tek dağıtmak yerine tek yerde, yığının
   kendisinde veriyoruz: yeni bir kart eklendiğinde de aynı ritme uyuyor. */
.qcw-stack {
  gap: var(--space-4);
}
/* Kaynak satırı boşluksuz yığınlarda (Güçlü/Zayıf sekmesi) kendi alt boşluğunu taşıyor; burada
   gap'i yığın devraldığı için ikisi üst üste binmesin. */
.qcw-stack > .qcw-source-row {
  margin-bottom: 0;
}
.qcw-main-root {
  height: 100%;
  display: flex;
  flex-direction: column;
}

@media (min-width: 1024px) {
  .qcw-graph-left {
    display: block;
    width: 25%;
  }
  .qcw-graph-right {
    width: 75%;
  }
  .qcw-radar-half {
    width: 50%;
  }
}

/* --- Kaynak filtre satırı ---------------------------------------------------------------------
   Kartın en üstünde, ekranın kendi filtre çubuğunun (Ders · Zaman aralığı) hemen altında: sıra
   ders, zaman, kaynak. Etiketli bir satır, çıplak bir çip yığınından farklı bir şey söylüyor —
   çipler bir EKSENİ paylaşıyor, rastgele bir açma/kapama kümesi değil.

   Bu çipler gerçek <button>: klavye, odak ve disabled durumu platformdan geliyor. Grafiklerin
   içindeki eski .qbd-source-item / .qbe-toggle-item div'leri tıklama işleyicisiydi ve klavyeyle
   erişilemiyordu; yeni satır o kusuru taşımıyor. */
.qcw-source-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}
/* Ekranın kendi filtre çubuğundaki "Ders" ve "Zaman aralığı" etiketleriyle AYNI tipografi
   (.sap-fgroup-lbl). Bu satır o çubuğun bir satır altında duruyor ve onun üçüncü grubu gibi
   okunmalı; büyük harfe çevrilmiş, harf aralığı açılmış 12px'lik hâli ise kardeşlerinin yanında
   başka bir aileden gelmiş gibi duruyordu. */
.qcw-source-row-label {
  font-size: var(--fs-md);
  font-weight: 700;
  color: var(--text-muted);
  flex-shrink: 0;
  /* Etiket → ilk çip arası, .sap-fgroup'un etiket→kontrol boşluğuna (var(--space-3) = 12px)
     eşitleniyor; satırın kendi 8px'lik gap'i çipler arasında kalıyor. */
  margin-right: 4px;
}
.qcw-source-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 13px;
  border-radius: 12px;
  /* Dinlenme hâli beyaz zeminli: seçili durumun teali bu beyazın ÜZERİNE bindiriliyor, yerine
     geçmiyor. Dolgu kaldırılınca seçili çip ~%85 saydam kalıyor ve sayfanın bulanık lekelerini
     gösteriyor — uygulamanın kendi çip bileşeninin de aynı gerekçeyle korduğu bir zemin. */
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(84, 187, 203, 0.35);
  color: var(--text-primary);
  font-family: var(--font-sans);
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
/* Yalnızca SEÇİLİ OLMAYAN çipe: seçili durumun rengini geçersiz kılmasın — bir hover bir durumu
   süsler, asla onun önüne geçmez. */
.qcw-source-chip:not(.qcw-source-chip--on):hover:not(:disabled) {
  border-color: rgba(15, 136, 156, 0.6);
  background: #fff;
}
.qcw-source-chip:focus-visible {
  outline: 2px solid rgba(15, 136, 156, 0.55);
  outline-offset: 2px;
}
.qcw-source-chip--on {
  background:
    linear-gradient(rgba(84, 187, 203, 0.16), rgba(84, 187, 203, 0.16)),
    rgba(255, 255, 255, 0.85);
  border-color: var(--brand, #0f889c);
  color: var(--text-primary);
}
.qcw-source-chip--on:hover:not(:disabled) {
  background:
    linear-gradient(rgba(84, 187, 203, 0.22), rgba(84, 187, 203, 0.22)),
    rgba(255, 255, 255, 0.85);
}
.qcw-source-chip:disabled {
  cursor: not-allowed;
}
/* Veri OLMAYAN kaynak. Salt opacity, "kapattım" ile "burada veri yok" arasındaki farkı taşımıyordu;
   ikisi de beyaz zeminli birer çip olarak görünüyordu. Kesikli kenarlık ve dolgusuz zemin, çipi bir
   KONTROL değil BOŞ BİR YUVA olarak okutuyor. */
.qcw-source-chip--empty {
  background: transparent;
  border-style: dashed;
  border-color: var(--border-subtle, rgba(15, 60, 70, 0.18));
  color: var(--text-secondary);
  box-shadow: none;
}
.qcw-source-chip-count {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-secondary);
  font-variant-numeric: tabular-nums;
}
/* Deneme Tahmini puan kartı — Sınavlar'ın % özetinden AYRI duruyor; üstündeki kısa not bunun neden
   ayrı olduğunu (puan başarı yüzdesine katılmaz, deneme tüm dersleri kapsar) söylüyor. */
.qcw-score-card {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}
.qcw-score-card-hint {
  font-size: var(--fs-sm);
  color: var(--text-muted);
}
`;
